import _regenerator from "D:/androidcode/zf_tms_vue/tms_vue/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import "core-js/modules/es6.array.sort";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/androidcode/zf_tms_vue/tms_vue/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { getDictionaryAll as _getDictionaryAll } from '@/api/systemData/dictionary';
import { UserListAll, getUserSelector } from '@/api/permission/user';
import { getPositionListAll, getPositionSelector } from '@/api/permission/position';
import { getRoleSelector } from '@/api/permission/role';
import { getPrintDevSelector } from '@/api/system/printDev';
var state = {
  dictionaryList: [],
  userList: [],
  userTree: [],
  positionList: [],
  positionTree: [],
  roleList: [],
  roleTree: [],
  printFlowTree: [],
  printFormTree: []
};
var mutations = {
  SET_DICTIONARY_LIST: function SET_DICTIONARY_LIST(state, dictionaryList) {
    state.dictionaryList = dictionaryList;
  },
  SET_USER_LIST: function SET_USER_LIST(state, userList) {
    state.userList = userList;
  },
  SET_USER_TREE: function SET_USER_TREE(state, userTree) {
    state.userTree = userTree;
  },
  SET_POSITION_LIST: function SET_POSITION_LIST(state, positionList) {
    state.positionList = positionList;
  },
  SET_POSITION_TREE: function SET_POSITION_TREE(state, positionTree) {
    state.positionTree = positionTree;
  },
  SET_ROLE_LIST: function SET_ROLE_LIST(state, roleList) {
    state.roleList = roleList;
  },
  SET_ROLE_TREE: function SET_ROLE_TREE(state, roleTree) {
    state.roleTree = roleTree;
  },
  SET_PRINT_FLOW_TREE: function SET_PRINT_FLOW_TREE(state, printTree) {
    state.printFlowTree = printTree;
  },
  SET_PRINT_FORM_TREE: function SET_PRINT_FORM_TREE(state, printTree) {
    state.printFormTree = printTree;
  }
};
var actions = {
  getDictionaryAll: function getDictionaryAll(_ref) {
    var commit = _ref.commit;
    return new Promise(function (resolve, reject) {
      _getDictionaryAll().then(function (res) {
        commit('SET_DICTIONARY_LIST', res.data.list);
        resolve(res.data.list);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getDictionaryData: function getDictionaryData(_ref2, info) {
    var state = _ref2.state,
      dispatch = _ref2.dispatch;
    return new Promise(/*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(resolve) {
        var list, data, json, arr, rowData, _findData;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              list = [], data = [], json = [];
              if (state.dictionaryList.length) {
                _context.n = 2;
                break;
              }
              _context.n = 1;
              return dispatch('getDictionaryAll');
            case 1:
              list = _context.v;
              _context.n = 3;
              break;
            case 2:
              list = state.dictionaryList;
            case 3:
              if (!info.sort) {
                _context.n = 5;
                break;
              }
              arr = list.filter(function (o) {
                return o.enCode === info.sort;
              });
              if (arr.length) {
                _context.n = 4;
                break;
              }
              return _context.a(2, resolve([]));
            case 4:
              data = arr[0];
              if (!info.id) {
                json = data.dictionaryList;
              } else {
                rowData = [];
                if (!data.isTree) {
                  rowData = data.dictionaryList.fliter(function (o) {
                    return o.id == info.id;
                  });
                } else {
                  _findData = function findData(list) {
                    for (var i = 0; i < list.length; i++) {
                      var e = list[i];
                      if (e.id == info.id) {
                        rowData[0] = e;
                        break;
                      }
                      if (e.children && e.children.length) {
                        _findData(e.children);
                      }
                    }
                  };
                  _findData(data.dictionaryList);
                }
                if (rowData.length) {
                  json = rowData[0];
                } else {
                  json = {
                    id: "",
                    fullName: ""
                  };
                }
              }
            case 5:
              resolve(json);
            case 6:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }());
  },
  getPositionList: function getPositionList(_ref4) {
    var state = _ref4.state,
      commit = _ref4.commit;
    return new Promise(function (resolve, reject) {
      if (!state.positionList.length) {
        getPositionListAll().then(function (res) {
          commit('SET_POSITION_LIST', res.data.list);
          resolve(res.data.list);
        }).catch(function (error) {
          reject(error);
        });
      } else {
        resolve(state.positionList);
      }
    });
  },
  getPositionTree: function getPositionTree(_ref5) {
    var state = _ref5.state,
      commit = _ref5.commit;
    return new Promise(function (resolve, reject) {
      if (!state.positionTree.length) {
        getPositionSelector().then(function (res) {
          commit('SET_POSITION_TREE', res.data.list);
          resolve(res.data.list);
        }).catch(function (error) {
          reject(error);
        });
      } else {
        resolve(state.positionTree);
      }
    });
  },
  getRoleList: function getRoleList(_ref6) {
    var state = _ref6.state,
      commit = _ref6.commit,
      dispatch = _ref6.dispatch;
    return new Promise(function (resolve, reject) {
      if (!state.roleList.length) {
        dispatch('getRoleTree').then(function (res) {
          var list = [];
          for (var i = 0; i < res.length; i++) {
            var item = res[i];
            if (item.children && item.children.length) {
              for (var j = 0; j < item.children.length; j++) {
                list.push(item.children[j]);
              }
            }
          }
          commit('SET_ROLE_LIST', list);
          resolve(list);
        }).catch(function (error) {
          reject(error);
        });
      } else {
        resolve(state.roleList);
      }
    });
  },
  getRoleTree: function getRoleTree(_ref7) {
    var state = _ref7.state,
      commit = _ref7.commit;
    return new Promise(function (resolve, reject) {
      if (!state.roleTree.length) {
        getRoleSelector().then(function (res) {
          commit('SET_ROLE_TREE', res.data.list);
          resolve(res.data.list);
        }).catch(function (error) {
          reject(error);
        });
      } else {
        resolve(state.roleTree);
      }
    });
  },
  getUserTree: function getUserTree(_ref8) {
    var state = _ref8.state,
      commit = _ref8.commit;
    return new Promise(function (resolve, reject) {
      if (!state.userTree.length) {
        getUserSelector().then(function (res) {
          commit('SET_USER_TREE', res.data.list);
          resolve(res.data.list);
        }).catch(function (error) {
          reject(error);
        });
      } else {
        resolve(state.userTree);
      }
    });
  },
  getUserList: function getUserList(_ref9) {
    var state = _ref9.state,
      commit = _ref9.commit;
    return new Promise(function (resolve, reject) {
      if (!state.userList.length) {
        UserListAll().then(function (res) {
          commit('SET_USER_LIST', res.data.list);
          resolve(res.data.list);
        }).catch(function (error) {
          reject(error);
        });
      } else {
        resolve(state.userList);
      }
    });
  },
  getUserInfo: function getUserInfo(_ref0, id) {
    var state = _ref0.state,
      dispatch = _ref0.dispatch;
    return new Promise(/*#__PURE__*/function () {
      var _ref1 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(resolve) {
        var list, item;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              list = [];
              if (state.userList.length) {
                _context2.n = 2;
                break;
              }
              _context2.n = 1;
              return dispatch('getUserList');
            case 1:
              list = _context2.v;
              _context2.n = 3;
              break;
            case 2:
              list = state.userList;
            case 3:
              item = list.filter(function (o) {
                return o.id === id;
              })[0]; // let name = item.realName + '/' + item.account
              resolve(item || {});
            case 4:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function (_x2) {
        return _ref1.apply(this, arguments);
      };
    }());
  },
  getPrintFlowTree: function getPrintFlowTree(_ref10) {
    var state = _ref10.state,
      commit = _ref10.commit;
    return new Promise(function (resolve, reject) {
      if (!state.printFlowTree.length) {
        getPrintDevSelector(1).then(function (res) {
          commit('SET_PRINT_FLOW_TREE', res.data.list);
          resolve(res.data.list);
        }).catch(function (error) {
          reject(error);
        });
      } else {
        resolve(state.printFlowTree);
      }
    });
  },
  getPrintFormTree: function getPrintFormTree(_ref11) {
    var state = _ref11.state,
      commit = _ref11.commit;
    return new Promise(function (resolve, reject) {
      if (!state.printFormTree.length) {
        getPrintDevSelector(2).then(function (res) {
          commit('SET_PRINT_FORM_TREE', res.data.list);
          resolve(res.data.list);
        }).catch(function (error) {
          reject(error);
        });
      } else {
        resolve(state.printFormTree);
      }
    });
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};